<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 fm-ctrl-container" [formGroup]="form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <p-radioButton
      [label]="'basic-profile.jurisdiction.drr-ccd-devices.devices-requiring-registration' | translate"
      [value]="'drr'"
      class="p-field-radio"
      formControlName="consumption_device_type"
      labelStyleClass="radio-label"
      name="consumption_device_type"></p-radioButton>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <p-radioButton
      [label]="'basic-profile.jurisdiction.drr-ccd-devices.controllable-drr-ccd-devices' | translate"
      [value]="'ccd'"
      class="p-field-radio"
      formControlName="consumption_device_type"
      labelStyleClass="radio-label"
      name="consumption_device_type"></p-radioButton>
  </div>
</div>
<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 info-container">
  <div>
    <i class="pi pi-info-circle icon-contr-dev-info"></i>
    {{ 'basic-profile.jurisdiction.drr-ccd-devices.controllable-devices-info' | translate }}
  </div>
  <div class="bold">{{ 'basic-profile.jurisdiction.drr-ccd-devices.which-devices-are-affected' | translate }}</div>
  <div class="pl-20">{{ 'basic-profile.jurisdiction.drr-ccd-devices.points-for-e-mobility' | translate }}</div>
  <div class="pl-20">{{ 'basic-profile.jurisdiction.drr-ccd-devices.electrically-operated-heat-pumps' | translate }}</div>
  <div class="pl-20">{{ 'basic-profile.jurisdiction.drr-ccd-devices.room-cooling-systems' | translate }}</div>
  <div class="pl-20">{{ 'basic-profile.jurisdiction.drr-ccd-devices.electricity-storage' | translate }}</div>
  <div>{{ 'basic-profile.jurisdiction.drr-ccd-devices.except-commercial-purposes' | translate }}</div>
</div>
